import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { Container, Grid, Paper } from '@mui/material';
import gpay from '../../../assest/img/icn_s_gpay.png';
import master from '../../../assest/img/icon-brand-master.png';
import visa from '../../../assest/img/icon-brand-visa.png';
import etc from '../../../assest/img/icon-feat-etc.svg';
import applepay from '../../../assest/img/icon-payment-applepay.png';
import paymentId from '../../../assest/img/icon-payment-id.png';
import pasmo from '../../../assest/img/icon-payment-pasmo.png';
import quicpay from '../../../assest/img/icon-payment-quicpay.png';
import suica from '../../../assest/img/icon-payment-suica.png';
import visatouch from '../../../assest/img/icon-payment-visatouch.jpg';

import step1 from '../../../assest/img/dang-ky.png';
import step4 from '../../../assest/img/download-2.png';
import step6 from '../../../assest/img/gui.png';
import step3 from '../../../assest/img/mail.png';
import step5 from '../../../assest/img/the.png';
import step2 from '../../../assest/img/thong-tin.png';

import languagesCam from '../../../assest/img/campuchia.png';
import languagesEng from '../../../assest/img/eng.png';
import languagesIndo from '../../../assest/img/indo.png';
import languagesChina from '../../../assest/img/TQ.png';
import languagesLatin from '../../../assest/img/latin.png';

import logo from '../../../assest/img/logo-gojapan-white.png';
import news2 from '../../../assest/img/new2.jpg';
import news1 from '../../../assest/img/news1.jpg';
import news4 from '../../../assest/img/news4.jpg';
import news3 from '../../../assest/img/ss-news3.png';

import scrolling from '../../../assest/img/scrolling.png';

import service1 from '../../../assest/img/services/apollo-idemitsu-shell.jpeg';
import service2 from '../../../assest/img/services/wowow.jpg';
import service3 from '../../../assest/img/services/point_01.jpeg';
import service4 from '../../../assest/img/services/merchant_01.jpeg';
import service5 from '../../../assest/img/services/services_classe.jpeg';
import service6 from '../../../assest/img/services/online-protection_01.jpeg';
import service7 from '../../../assest/img/services/abema-tv.jpeg';
import service8 from '../../../assest/img/services/rentacar-marutoku_01.jpeg';
import service9 from '../../../assest/img/services/careco_01.jpeg';
import service10 from '../../../assest/img/services/assistance-service_01.jpeg';
import service11 from '../../../assest/img/services/tabi-desk_01.jpeg';
import service12 from '../../../assest/img/services/parco_02.jpeg';
import service13 from '../../../assest/img/services/eplus_01.jpeg';
import service14 from '../../../assest/img/services/super-value-plus_01.jpeg';
import service15 from '../../../assest/img/services/tokugai_01.jpeg';
import service16 from '../../../assest/img/services/hertz_02.jpeg';
import service17 from '../../../assest/img/services/etc-card_02.jpeg';
import service18 from '../../../assest/img/services/jr-explus.jpeg';

import useScrollHandler from 'hooks/useScroll';
import './style.scss';

import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useState } from 'react';
import { useRef } from 'react';
CardInfo.propTypes = {};

function CardInfo(props) {
    const { t, i18n } = useTranslation();
    // debugger;
    // const language = localStorage.getItem('languages');
    const [lang, setLang] = useState();

    // const scroll = useScrollHandler(680);
    const scrollMobile = useScrollHandler(650);
    const scrollTablet = useScrollHandler(600);

    // const [executeScroll, elRef] = useExcecuteScroll();
    // useEffect(executeScroll, []);
    // const titleRef = useRef();
    // console.log(titleRef);
    // const handleScrollClick = (value) => {
    //     console.log(titleRef);
    //     titleRef.current.scrollIntoView({ behavior: 'smooth' });
    // };

    useEffect(() => {
        let img = '';
        switch (i18n.language) {
            case 'en':
            case 'fil': {
                img = languagesEng;
                break;
            }
            case 'km': {
                img = languagesCam;
                break;
            }
            case 'zh': {
                img = languagesChina;
                break;
            }
            case 'id': {
                img = languagesIndo;
                break;
            }
            case 'pt': {
                img = languagesLatin;
                break;
            }
            default:
                img = step1;
        }
        setLang(img);
    }, [i18n.language]);

    return (
        <Container maxWidth="xl">
            <Grid
                container
                spacing={{ xs: 2, sm: 6 }}
                columns={{ xs: 4, sm: 12 }}
            >
                <Grid item xs={12} sm={3}>
                    <div
                        // className={
                        //     scroll ? 'scrolling fixed-card' : 'scrolling'
                        // }
                        className="scrolling"
                    >
                        <img src={scrolling} alt="saison-card" />
                        <h4>GO JAPAN x SAISON CARD Digital</h4>
                        <span>
                            <ShoppingCartOutlinedIcon
                                fontSize="12"
                                sx={{ marginRight: '3px' }}
                            />
                            {t('hero_title2')}
                        </span>
                        <div>
                            <a
                                rel="noopener noreferrer"
                                target="_blank"
                                href="https://www.saisoncard.co.jp/lineup/select/digital.php?cd=14V1&sd=207&fbclid=IwAR3gt_RsvkfWzxrloVMI5IB17NyQgKJgzeITxEgFu6lx0E5fa5i0ymdIGUc"
                                className="btn"
                            >
                                {t('button')}
                            </a>
                        </div>
                    </div>
                    <Grid container>
                        <Grid item xs={12} sm={12}>
                            <div
                                className={
                                    scrollTablet
                                        ? 'scrolling-tablet'
                                        : 'scrolling-none'
                                }
                            >
                                <Container
                                    maxWidth="xl"
                                    sx={{ paddingLeft: '0 !important' }}
                                >
                                    <img src={logo} alt="logo" width={150} />
                                </Container>
                            </div>
                        </Grid>
                    </Grid>

                    <div
                        className={
                            scrollMobile ? 'scrolling-mobile' : 'scrolling-none'
                        }
                    >
                        <div className="scrolling-wrap">
                            <div className="left-content">
                                <img
                                    src={scrolling}
                                    alt="saison-card"
                                    width={52}
                                    height={32}
                                />
                                <div className="text">
                                    <h4>GO JAPAN x SAISON CARD</h4>
                                    <span>
                                        <ShoppingCartOutlinedIcon fontSize="12" />
                                        {t('hero_title2')}
                                    </span>
                                </div>
                            </div>
                            <a
                                rel="noopener noreferrer"
                                target="_blank"
                                href="https://www.saisoncard.co.jp/lineup/select/digital.php?cd=14V1&sd=207&fbclid=IwAR3gt_RsvkfWzxrloVMI5IB17NyQgKJgzeITxEgFu6lx0E5fa5i0ymdIGUc"
                                className="btn"
                            >
                                {t('button')}
                            </a>
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={9}>
                    <div className="info-table">
                        <h3 className="section-title">{t('info_title')}</h3>
                        <dl>
                            <dt>
                                <span>{t('table_title1')}</span>
                            </dt>
                            <dd>
                                <ul>
                                    <li>
                                        <img src={visa} alt="visa" />
                                    </li>
                                    <li>
                                        <img src={master} alt="master" />
                                    </li>
                                </ul>
                            </dd>
                            <dt>
                                <span>{t('table_title2')}</span>
                            </dt>
                            <dd>{t('table_des1')}</dd>
                            <dt>
                                <span>{t('table_title3')}</span>
                            </dt>
                            <dd>{t('table_des2')}</dd>
                            <dt>
                                <span>{t('table_title4')}</span>
                            </dt>
                            <dd>{t('table_des3')}</dd>
                            <dt>
                                <span>{t('table_title5')}</span>
                            </dt>
                            <dd>
                                <ul>
                                    <li className="etc-card">
                                        <img src={etc} alt="etc" />
                                        <span> {t('table_des4')}</span>
                                    </li>
                                </ul>
                            </dd>
                            <dt>
                                <span>{t('table_title6')}</span>
                            </dt>
                            <dd>
                                <ul>
                                    <li>
                                        <img src={visatouch} alt="visa touch" />
                                    </li>
                                    <li>
                                        <img src={applepay} alt="applepay" />
                                    </li>
                                    <li>
                                        <img src={quicpay} alt="quicpay" />
                                    </li>
                                    <li>
                                        <img src={gpay} alt="gpay" />
                                    </li>
                                    <li>
                                        <img src={paymentId} alt="paymentId" />
                                    </li>
                                    <li>
                                        <img src={suica} alt="suica" />
                                    </li>
                                    <li>
                                        <img src={pasmo} alt="pasmo" />
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                        <div className="info-des">
                            <p>{t('table_des5')}</p>
                            <p>{t('table_des6')}</p>
                        </div>
                        <div className="info-content">
                            {/* old version */}
                            {/* <span className="info-header">
                                {t('info.info_register')} :
                            </span>
                            <ul>
                                <li>{t('info.list_title')}</li>
                                <li>{t('info.list_title1')}</li>
                                <li>{t('info.list_title2')}</li>
                            </ul>
                            <span>{t('info.list_title3')}</span> */}
                            {/* <p>
                                <a
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href="https://faq.saisoncard.co.jp/saison/search?site=OA5LHO14&charset=UTF-8&query=SAISON+CARD+Digital&_gl=1*mechbr*_ga*MTk1MzQyNjg0LjE2NTQ1NjkwODM.*_ga_BKKP87CX6T*MTY1NTE3OTkxNi45LjEuMTY1NTE4MDM4Ny42MA..#_ga=2.52394350.633075837.1655083587-195342684.1654569083"
                                >
                                    {t('info.link')}
                                    <LibraryAddOutlinedIcon
                                        sx={{ verticalAlign: 'sub' }}
                                    />
                                </a>
                            </p>
                            <span className="info-header">
                                {t('info.info_note')} :
                            </span>
                            <ul>
                                <li>{t('info.list_title4')}</li>
                                <li>{t('info.list_title5')}</li>
                                <li>{t('info.list_title6')}</li>
                                <li>{t('info.list_title7')}</li>
                            </ul> */}
                        </div>
                    </div>

                    {/* section props */}
                    <div className="props-section">
                        <h3 className="section-title">{t('pros_title')}</h3>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                        position: 'relative',
                                        '&:hover': {
                                            backgroundColor: '#f7f7f7',
                                        },
                                    }}
                                >
                                    <div className="props-info">
                                        <a href="#section-1">
                                            <span className="props-title">
                                                {t('pros_title1')}
                                            </span>
                                            <span className="gradient"></span>
                                            <p>{t('pros_des1')}</p>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                        position: 'relative',
                                        '&:hover': {
                                            backgroundColor: '#f7f7f7',
                                        },
                                    }}
                                >
                                    <div className="props-info">
                                        <a href="#section-2">
                                            <span className="props-title">
                                                {t('pros_title2')}
                                            </span>
                                            <span className="gradient"></span>
                                            <p>{t('pros_des2')}</p>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                        position: 'relative',
                                        '&:hover': {
                                            backgroundColor: '#f7f7f7',
                                        },
                                    }}
                                >
                                    <div className="props-info">
                                        <a href="#section-3">
                                            <span className="props-title">
                                                {t('pros_title3')}
                                            </span>
                                            <span className="gradient"></span>
                                            <p>{t('pros_des3')}</p>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                        position: 'relative',
                                        '&:hover': {
                                            backgroundColor: '#f7f7f7',
                                        },
                                    }}
                                >
                                    <div className="props-info">
                                        <a href="#section-4">
                                            <span className="props-title">
                                                {t('pros_title4')}
                                            </span>
                                            <span className="gradient"></span>
                                            <p>{t('pros_des4')}</p>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                        position: 'relative',
                                        '&:hover': {
                                            backgroundColor: '#f7f7f7',
                                        },
                                    }}
                                >
                                    <div className="props-info">
                                        <a href="#section-5">
                                            <span className="props-title">
                                                {t('pros_title5')}
                                            </span>
                                            <span className="gradient"></span>
                                            <p>{t('pros_des5')}</p>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                        position: 'relative',
                                        '&:hover': {
                                            backgroundColor: '#f7f7f7',
                                        },
                                    }}
                                >
                                    <div className="props-info">
                                        <a href="#section-6">
                                            <span className="props-title">
                                                {t('pros_title6')}
                                            </span>
                                            <span className="gradient"></span>
                                            <p>{t('pros_des6')}</p>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                        position: 'relative',
                                        '&:hover': {
                                            backgroundColor: '#f7f7f7',
                                        },
                                    }}
                                >
                                    <div className="props-info">
                                        <a href="#section-7">
                                            <span className="props-title">
                                                {t('pros_title7')}
                                            </span>
                                            <span className="gradient"></span>
                                            <p>{t('pros_des7')}</p>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                        position: 'relative',
                                        '&:hover': {
                                            backgroundColor: '#f7f7f7',
                                        },
                                    }}
                                >
                                    <div className="props-info">
                                        <a href="#section-8">
                                            <span className="props-title">
                                                {t('pros_title8')}
                                            </span>
                                            <span className="gradient"></span>
                                            <p>{t('pros_des8')}</p>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                        </Grid>
                    </div>

                    {/* section-1 */}
                    <div className="scroll-container">
                        <div className="section-1" id="section-1">
                            <div className="header-section">
                                <span className="props-btn">
                                    {t('pros_title1')}
                                </span>
                                <span className="props-text">
                                    {t('pros_detail1_value1')}
                                </span>
                            </div>
                            <div className="description">
                                <h4 className="des-text">
                                    {t('pros_detail1_value2')}
                                </h4>
                                <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 12, md: 12 }}
                                >
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Grid
                                            container
                                            columns={{ xs: 4, sm: 12, md: 12 }}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                sm={4}
                                                sx={{
                                                    textAlign: 'center',
                                                    paddingY: '20px',
                                                }}
                                            >
                                                <img src={lang} alt="dang ky" />
                                                <span className="img-description">
                                                    {t('pros_detail1_value4')}
                                                </span>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={4}
                                                sx={{
                                                    textAlign: 'center',
                                                    paddingY: '20px',
                                                }}
                                            >
                                                <img
                                                    src={step2}
                                                    alt="nhap thong tin"
                                                />
                                                <span className="img-description">
                                                    {t('pros_detail1_value5')}
                                                </span>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={4}
                                                sx={{
                                                    textAlign: 'center',
                                                    paddingY: '20px',
                                                }}
                                            >
                                                <img
                                                    src={step3}
                                                    alt="nhap thong tin"
                                                />
                                                <span className="img-description">
                                                    {t('pros_detail1_value6')}
                                                </span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Grid
                                            container
                                            columns={{ xs: 4, sm: 12, md: 12 }}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                sm={4}
                                                sx={{
                                                    textAlign: 'center',
                                                    paddingY: '20px',
                                                }}
                                            >
                                                <img
                                                    src={step4}
                                                    alt="download"
                                                />
                                                <span className="img-description">
                                                    {t('pros_detail1_value7')}
                                                </span>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={4}
                                                sx={{
                                                    textAlign: 'center',
                                                    paddingY: '20px',
                                                }}
                                            >
                                                <img
                                                    src={step5}
                                                    alt="hien thi ung dung"
                                                />
                                                <span className="img-description">
                                                    {t('pros_detail1_value8')}
                                                </span>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={4}
                                                sx={{
                                                    textAlign: 'center',
                                                    paddingY: '20px',
                                                }}
                                            >
                                                <img
                                                    src={step6}
                                                    alt="gui the"
                                                />
                                                <span className="img-description">
                                                    {t('pros_detail1_value9')}
                                                </span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>

                        {/* section-2 */}
                        <div className="section-2" id="section-2">
                            <div className="header-section">
                                <span className="props-btn">
                                    {t('pros_title2')}
                                </span>
                                <span className="props-text">
                                    {t('pros_detail2_value1')}
                                </span>
                            </div>
                            <div className="description">
                                <div className="video-wrap">
                                    <div className="video-container">
                                        <iframe
                                            src="https://www.youtube.com/embed/MSe2cHxoSTE"
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* section-3 */}
                        <div className="section-3" id="section-3">
                            <div className="header-section">
                                <span className="props-btn">
                                    {t('pros_title3')}
                                </span>
                                <span className="props-text">
                                    {t('pros_detail3_value1')}
                                </span>
                            </div>
                            <div className="description">
                                <h4>{t('pros_detail3_value2')}</h4>
                                <div className="grid-container">
                                    <div className="wrap">
                                        <img src={news1} alt="news" />
                                    </div>
                                    <div className="content">
                                        <p>{t('pros_detail3_value3')}</p>
                                        <p>{t('pros_detail3_value4')}</p>
                                        <p>{t('pros_detail3_value5')}</p>
                                        <p className="bold-text">
                                            {t('pros_detail3_value6')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* section-4 */}
                        <div className="section-4" id="section-4">
                            <div className="header-section">
                                <span className="props-btn">
                                    {t('pros_title4')}
                                </span>
                                <span className="props-text">
                                    {t('pros_detail4_value1')}
                                </span>
                            </div>
                            <div className="description">
                                <h4>{t('pros_detail4_value2')}</h4>
                                <div className="content">
                                    <p>{t('pros_detail4_value3')}</p>
                                    <p className="link-text">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://www.saisoncard.co.jp/customer-support/information/20211018_01/"
                                        >
                                            {t('pros_detail4_value4')}

                                            <LibraryAddOutlinedIcon
                                                sx={{ verticalAlign: 'sub' }}
                                            />
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* section-5 */}
                        <div className="section-5" id="section-5">
                            <div className="header-section">
                                <span className="props-btn">
                                    {t('pros_title5')}
                                </span>
                                <span className="props-text">
                                    {t('pros_detail5_value1')}
                                </span>
                            </div>
                            <div className="description">
                                <h4>{t('pros_detail5_value2')}</h4>
                                <div className="grid-container">
                                    <div className="wrap">
                                        <img src={news2} alt="news 2" />
                                    </div>
                                    <div className="content">
                                        <p>{t('pros_detail5_value3')}</p>
                                    </div>
                                </div>
                            </div>
                            <ul>
                                <li>{t('pros_detail5_value4')}</li>
                                <li>{t('pros_detail5_value5')}</li>
                                <li>{t('pros_detail5_value6')}</li>
                                <li>{t('pros_detail5_value7')}</li>
                                <li>{t('pros_detail5_value8')}</li>
                                <li>{t('pros_detail5_value9')}</li>
                                <li>{t('pros_detail5_value10')}</li>
                                <li>{t('pros_detail5_value11')}</li>
                            </ul>
                        </div>

                        {/* section-6 */}
                        <div className="section-6" id="section-6">
                            <div className="header-section">
                                <span className="props-btn">
                                    {t('pros_title6')}
                                </span>
                                <span className="props-text">
                                    {t('pros_detail6_value1')}
                                </span>
                            </div>
                            <div className="description">
                                <h4>{t('pros_detail6_value2')}</h4>
                                <div className="grid-container">
                                    <div className="wrap">
                                        <img src={news3} alt="news 3" />
                                    </div>
                                    <div className="content">
                                        <p>{t('pros_detail6_value3')}</p>
                                    </div>
                                </div>
                                <ul>
                                    <li>{t('pros_detail6_value4')}</li>
                                </ul>
                            </div>
                        </div>

                        {/* section-7 */}
                        <div className="section-7" id="section-7">
                            <div className="header-section">
                                <span className="props-btn">
                                    {t('pros_title7')}
                                </span>
                                <span className="props-text">
                                    {t('pros_detail7_value1')}
                                </span>
                            </div>
                            <div className="description">
                                <h4>{t('pros_detail7_value2')}</h4>
                                <div className="content">
                                    <ul>
                                        <li>{t('pros_detail7_value3')}</li>
                                        <li>{t('pros_detail7_value4')}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* section-8 */}
                        <div className="section-8" id="section-8">
                            <div className="header-section">
                                <span className="props-btn">
                                    {t('pros_title8')}
                                </span>
                                <span className="props-text">
                                    {t('pros_detail8_value1')}
                                </span>
                            </div>
                            <div className="description">
                                {/* <h4>{t('pros_detail8_value2')}</h4> */}
                                <div className="grid-container">
                                    <div className="wrap">
                                        <img src={news4} alt="news 4" />
                                    </div>
                                    <div className="content">
                                        <p>{t('pros_detail8_value2')}</p>
                                        <ul>
                                            <li>{t('pros_detail8_value3')}</li>
                                            <li>{t('pros_detail8_value4')}</li>
                                        </ul>
                                        <p>
                                            <a
                                                rel="noopener noreferrer"
                                                target="_blank"
                                                href="https://www.saisoncard.co.jp/services/contactless.html"
                                            >
                                                {t('pros_detail8_value5')}
                                                <LibraryAddOutlinedIcon
                                                    sx={{
                                                        paddingLeft: '5px',
                                                        verticalAlign: 'sub',
                                                    }}
                                                />
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* service section*/}
                    <div className="service-section">
                        <h3 className="section-title">{t('service_title')}</h3>
                        <Grid container spacing={{ xs: 2, sm: 4, md: 6 }}>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://www.saisoncard.co.jp/creditcard/benefits-service/expy/"
                                        >
                                            <img
                                                src={service18}
                                                alt="service18"
                                            />
                                            <div>
                                                <h4>{t('service_value1')}</h4>
                                                <p>{t('service_value2')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://www.saisoncard.co.jp/creditcard/benefits-service/apollostation-idemitsu-shell/"
                                        >
                                            <img
                                                src={service1}
                                                alt="service1"
                                            />
                                            <div>
                                                <h4>{t('service_value3')}</h4>
                                                <p>{t('service_value4')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://www.saisoncard.co.jp/creditcard/benefits-service/wowow/"
                                        >
                                            <img
                                                src={service2}
                                                alt="service2"
                                            />
                                            <div>
                                                <h4>{t('service_value5')}</h4>
                                                <p>{t('service_value6')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://www.saisoncard.co.jp/aqf-point/"
                                        >
                                            <img
                                                src={service3}
                                                alt="service3"
                                            />
                                            <div>
                                                <h4>{t('service_value7')}</h4>
                                                <p>{t('service_value8')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://saisoncard.mapion.co.jp/b/saisoncard_merchant/attr/"
                                        >
                                            <img
                                                src={service4}
                                                alt="service4"
                                            />
                                            <div>
                                                <h4>{t('service_value9')}</h4>
                                                <p>{t('service_value10')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://www.saisoncard.co.jp/service/app/classe/"
                                        >
                                            <img
                                                src={service5}
                                                alt="service5"
                                            />
                                            <div>
                                                <h4>{t('service_value11')}</h4>
                                                <p>{t('service_value12')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://faq.saisoncard.co.jp/saison/detail?site=OA5LHO14&id=2229&_gl=1*18q4xdc*_ga*NDQ1Njk3ODE2LjE2NTQ3NDU3MTM.*_ga_BKKP87CX6T*MTY1NTk2OTg3NC4yNS4xLjE2NTU5NzEwNzIuNjA.#_ga=2.159867325.1224038906.1655344985-445697816.1654745713"
                                        >
                                            <img
                                                src={service6}
                                                alt="service6"
                                            />
                                            <div>
                                                <h4>{t('service_value13')}</h4>
                                                <p>{t('service_value14')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://www.saisoncard.co.jp/static/creditcard/benefits-service/abema/"
                                        >
                                            <img
                                                src={service7}
                                                alt="service7"
                                            />
                                            <div>
                                                <h4>{t('service_value15')}</h4>
                                                <p>{t('service_value16')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://car.orix.co.jp/campaigns_page/?campk=48"
                                        >
                                            <img
                                                src={service8}
                                                alt="service8"
                                            />
                                            <div>
                                                <h4>{t('service_value17')}</h4>
                                                <p>{t('service_value18')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://saisoncard.mapion.co.jp/b/saisoncard_merchant/info/ME01857/?page=poi"
                                        >
                                            <img
                                                src={service9}
                                                alt="service9"
                                            />
                                            <div>
                                                <h4>{t('service_value19')}</h4>
                                                <p>{t('service_value20')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://www.assistancedesk.jp/assistancedesk/desktop.html"
                                        >
                                            <img
                                                src={service10}
                                                alt="service10"
                                            />
                                            <div>
                                                <h4>{t('service_value21')}</h4>
                                                <p>{t('service_value22')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://saisoncard.mapion.co.jp/b/saisoncard_merchant/info/ME01833/"
                                        >
                                            <img
                                                src={service11}
                                                alt="service11"
                                            />
                                            <div>
                                                <h4>{t('service_value23')}</h4>
                                                <p>{t('service_value24')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://point.parco.jp/"
                                        >
                                            <img
                                                src={service12}
                                                alt="service12"
                                            />
                                            <div>
                                                <h4>{t('service_value25')}</h4>
                                                <p>{t('service_value26')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://w1.onlineticket.jp/sf/saison/web"
                                        >
                                            <img
                                                src={service13}
                                                alt="service13"
                                            />
                                            <div>
                                                <h4>{t('service_value27')}</h4>
                                                <p>{t('service_value28')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://hoken.saisoncard.co.jp/svp/"
                                        >
                                            <img
                                                src={service14}
                                                alt="service14"
                                            />
                                            <div>
                                                <h4>{t('service_value29')}</h4>
                                                <p>{t('service_value30')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://bs.benefit-one.co.jp/bs/sccsb/pages/bo/csb/cmn/csbTop.faces?cs=3"
                                        >
                                            <img
                                                src={service15}
                                                alt="service15"
                                            />
                                            <div>
                                                <h4>{t('service_value31')}</h4>
                                                <p>{t('service_value32')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://www.saisoncard.co.jp/creditcard/benefits-service/hertz/"
                                        >
                                            <img
                                                src={service16}
                                                alt="service16"
                                            />
                                            <div>
                                                <h4>{t('service_value33')}</h4>
                                                <p>{t('service_value34')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <Paper
                                    sx={{
                                        height: '100%',
                                    }}
                                >
                                    <div className="service-info">
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href="https://www.saisoncard.co.jp/creditcard/benefits-service/etc-card/"
                                        >
                                            <img
                                                src={service17}
                                                alt="service17"
                                            />
                                            <div>
                                                <h4>{t('service_value35')}</h4>
                                                <p>{t('service_value36')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </Paper>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        </Container>
    );
}

export default CardInfo;
